// extracted by mini-css-extract-plugin
export default {"loading":"prizeManagement_loading__c4qax","h5Wrap":"prizeManagement_h5Wrap__WNZRY"};